import { Observable } from 'rxjs/Observable'

export class Location {
  latLng: number[]
  distance?: number

  constructor(latLng: number[]) {
    this.latLng = latLng
  }
}

export class User {
    static readonly malePictureUrl = 'https://scontent.xx.fbcdn.net/v/t1.0-1/s200x200/10354686_10150004552801856_220367501106153455_n.jpg'
    static readonly femalePictureUrl = 'https://scontent.xx.fbcdn.net/v/t1.0-1/s200x200/1379841_10150004552801901_469209496895221757_n.jpg'

    uid: string
    firstname: string
    lastname: string
    email: string
    birthday: string
    description: string
    images: string[]
    credits: number
    subExpirationDate: number | null
    city: string
    country: string
    location$: Observable<Location>
    preferences?: {
      male: boolean
      female: boolean
      minAge: number
      maxAge: number
      radius: number
      follow: boolean
    }

    static getPictureUrl(url: string) {
      if (url.includes(this.malePictureUrl)) {
        return '../../../assets/img/users/default_male.png'
      }

      if (url.includes(this.femalePictureUrl)) {
        return '../../../assets/img/users/default_female.png'
      }

      return url
    }

    get position() {
      let position = ''

      if (this.city) {
        position += this.city
      }

      if (this.country) {
        position += position.length > 0 ? ', ' : ''
        position += this.country
      }

      return position
    }

    getPictures() {
      const pictures: string[] = []

      for (let i = 0 ; i < this.images.length ; i++) {
        const image = this.getPicture(i)
        pictures.push(image)
      }

      return pictures
    }

    getPrimaryPicture() {
      return this.getPicture(0)
    }

    getPicture(index: number) {
      const image = this.images[index]

      if (image) {
        return User.getPictureUrl(image)
      }

      return null
    }

    isSubscribed(): boolean {
      return this.subExpirationDate && this.subExpirationDate >= (+new Date())
    }

    getSubExpirationDate(): number {
      return this.subExpirationDate
    }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/users/shared/user.model.ts